import type { AuthUser } from './session';

export function hasPermission(user: AuthUser | null, permissionKey: string): boolean {
  const permissions = user?.role?.permissions;
  if (!permissions) return false;
  return permissions.includes('full_access') || permissions.includes(permissionKey);
}